import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBookmark as faBookmarkSolid, faUsers } from '@fortawesome/free-solid-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import formattedMoney from '../../utils/formatMoney';

const PLATFORM_STYLE = {
    shopee: { label: 'Shopee', bg: '#EE4D2D', color: '#fff' },
    lazada: { label: 'Lazada', bg: '#0F146B', color: '#fff' },
    tiktok: { label: 'TikTok', bg: '#010101', color: '#fff' },
};

function TrendingFeedCard({ product, onBuy, onSave, isSaved }) {
    const badge = PLATFORM_STYLE[product.platform] || { label: product.platform, bg: '#888', color: '#fff' };

    return (
        <div className="bg-surface rounded-xl shadow-sm p-3 flex gap-3">
            {/* Ảnh sản phẩm */}
            <div className="relative w-24 h-24 flex-shrink-0 rounded-lg overflow-hidden bg-surface-muted">
                <img
                    src={product.productImage}
                    alt={product.productName}
                    className="w-full h-full object-cover"
                />
                <span
                    className="absolute bottom-0 left-0 right-0 text-center text-[8px] font-bold py-0.5"
                    style={{ backgroundColor: badge.bg, color: badge.color }}
                >
                    {badge.label}
                </span>
            </div>

            {/* Info */}
            <div className="flex-1 flex flex-col gap-1 min-w-0">
                <p className="text-sm font-semibold leading-tight line-clamp-2 text-content">{product.productName}</p>
                <p className="text-xs text-content-3 truncate">{product.shopName}</p>

                <div className="flex items-center gap-2 flex-wrap">
                    <span className="text-base font-bold text-red-500">{formattedMoney.format(product.productPrice)}</span>
                    {product.commission > 0 && (
                        <span className="text-[10px] bg-green-50 border border-green-100 text-green-700 font-semibold px-1.5 py-0.5 rounded-full">
                            💰 ~{formattedMoney.format(product.commission)}
                        </span>
                    )}
                </div>

                {/* Activity count */}
                {product.activityCount > 0 && (
                    <div className="flex items-center gap-1">
                        <FontAwesomeIcon icon={faUsers} className="text-content-3 text-[9px]" />
                        <span className="text-[10px] text-content-3">{product.activityCount.toLocaleString()} người đã xem</span>
                    </div>
                )}

                {/* Actions */}
                <div className="flex gap-2 mt-auto pt-1">
                    <button
                        onClick={() => onBuy(product)}
                        className="flex-1 py-1.5 bg-gradient-to-r from-primary-500 to-orange-400 text-white text-xs font-bold rounded-lg hover:opacity-90 transition-opacity shadow-sm"
                    >
                        Mua ngay
                    </button>
                    <button
                        onClick={() => onSave(product)}
                        className={`w-8 h-8 flex items-center justify-center rounded-lg border transition-colors ${
                            isSaved
                                ? 'border-primary-300 bg-primary-50 text-primary-500'
                                : 'border-line text-content-3 hover:bg-surface-sunken'
                        }`}
                        title={isSaved ? 'Bỏ lưu' : 'Lưu sản phẩm'}
                    >
                        <FontAwesomeIcon icon={isSaved ? faBookmarkSolid : faBookmarkRegular} size="sm" />
                    </button>
                </div>
            </div>
        </div>
    );
}

export default TrendingFeedCard;
